import React, { ChangeEvent } from "react";
import { NumberInputProps } from "../../types/screensTypes";
import styles from "./NumberInput.module.css";

const NumberInput: React.FC<NumberInputProps> = ({
    placeholder,
    size = "small",
    value,
    onChange,
    min = 0,
    max,
    hasError = false,
    name,
    onBlur,
    className = "",
    fullWidth = false,
    disabled = false,
    readOnly = false,
}) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const newValue = parseInt(e.target.value);

        if (!isNaN(newValue)) {
            if (max !== undefined && newValue > max) {
                const clampedEvent = {
                    ...e,
                    target: {
                        ...e.target,
                        value: max.toString(),
                    },
                };
                onChange(clampedEvent);
                return;
            }

            if (min !== undefined && newValue < min) {
                const clampedEvent = {
                    ...e,
                    target: {
                        ...e.target,
                        value: min.toString(),
                    },
                };
                onChange(clampedEvent);
                return;
            }
        }

        onChange(e);
    };

    const sizeClass = size === "medium" ? styles.medium : styles.small;

    return (
        <input
            className={[
                sizeClass,
                hasError ? styles.hasError : "",
                fullWidth ? styles.fullWidth : "",
                // Legacy hooks for parent [data-rw-control] / string overrides during migration
                size === "medium" ? "number-input-medium" : "number-input-small",
                hasError ? "number-input-has-error" : "",
                className,
            ]
                .filter(Boolean)
                .join(" ")}
            data-rw-control="number-input"
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            type="number"
            min={min}
            max={max}
            name={name}
            onBlur={onBlur}
            disabled={disabled}
            readOnly={readOnly}
        />
    );
};

export default NumberInput;
